<template>
  <div>
    <footer class="footer">
      <div class="container">
        <div class="columns is-mobile is-centered is-vcentered is-multiline">
          <div class="column is-12 has-text-centered">
            <div class="content">
              Copyright © {{new Date().getFullYear()}} -
              <strong>Mundo Fotográfico</strong> - Todos los derechos reservados
            </div>
          </div>
          <div class="column is-narrow">
            <div class="tags" style="width: 75px;">
              <span class="tag is-dark is-primary">versión [<strong>{{versionWeb}}</strong>]</span>
            </div>
          </div>
          <div class="column is-12 has-text-centered">
            <router-link
            :to="{name: 'sucursal'}"
          >Sucursal</router-link> .
          <router-link
            :to="{name: 'nosotros'}"
          >Nosotros</router-link> .
          <router-link
            :to="{name: 'contacto'}"
          >Contacto</router-link>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      versionWeb: process.env.VUE_APP_VERSION
    }
  }
}
</script>
